/**
 * Who may see the assistant: holders of `CRM_ASSISTANT`, and nobody else.
 *
 * One check for both doors — the CRM's subheader window and the extension's orb — and the same one
 * the backend enforces on askAssistant, assistantUsage and the conversation archive, so neither door
 * offers a window whose every request would be refused. The permission is seeded with no holders:
 * the assistant is closed until an administrator assigns the "CRM Assistant" role.
 *
 * It replaces a build-time constant that showed the CRM window to every user, and the extension's
 * borrowed `LEAD_AI_SUGGESTION_ACCESS`, which never meant "may use the assistant".
 */
export const canAskAssistant = (user) => user?.permissions?.CRM_ASSISTANT === 1;
